import { combineReducers } from "redux";
import session from "./session";
import notifications from "./notificatons";
import server from "./server";
import appearance from "./appearance";
import dashboard from "./dashboard";

/** Create the root reducer combining all feature reducers. */
export default function createRootReducer() {
  return combineReducers({
    session,
    notifications,
    server,
    appearance,
    dashboard,
  });
}
